var _defs, _polygon, _path, _polygon2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeProjectRulesSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009ad9;}.cls-2{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HomeProjectRules_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25 13 29 13 29 6 32 6 27 0 22 6 25 6 25 13"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32,25.84V23.75l-1.44-.42-.66-1.57.73-1.32L29.15,19l-1.32.73L26.26,19l-.42-1.44H23.76L23.34,19l-1.57.66L20.45,19,19,20.44l.73,1.32L19,23.33l-1.44.42v2.09l1.44.42.66,1.57L19,29.15l1.48,1.48,1.32-.73,1.57.66L23.76,32h2.08l.42-1.44,1.57-.66,1.32.73,1.48-1.48-.73-1.32.66-1.57Zm-7.2,2a3,3,0,1,1,3-3A3,3,0,0,1,24.8,27.8Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.04 4 2 10.75 2 28 8 28 12 28 13.26 28 13.67 28 15 28 15 26 12.67 26 12 26 8 26 4 26 4 13 10 13 10 6 18 6 18 12 18 13.66 18 18.58 20 16.58 20 12.66 20 12 20 4 9.04 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeProjectRulesSvg);
export default __webpack_public_path__ + "static/media/HomeProjectRules_svg.6867938020e56d1f708896078c4e7555.svg";
export { ForwardRef as ReactComponent };